import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Text } from '~/components/atomic';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 8px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_2};
    gap: 8px;
  `}
`;

export const TopWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    width: 100%;
  `}
`;

export const CommentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    align-self: stretch;
    padding: 4px 8px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_5_alpha};
  `}
`;

export const CommentTagWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  padding: 4px 0px;
  gap: 8px;
`;

export const EllipsisText = styled(Text)`
  ${(props) => props.theme.mixins.text.ellipsis_1}
`;
